import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Inject } from 'vue-di-container';
import WithRender from './CITCKeywords.html';
import { CITCKeywordsModel } from './CITCKeywordsModel';
import CITCKeywordsService from './CITCKeywordsService';
import { Toaster } from '../../Services/toast';
import UserService from '../../shared/userService/UserService';
import UserRoleService from '../../shared/userService/UserRoleService';

@WithRender
@Component({
    components: {
    },
    diProvide: [
        CITCKeywordsService,
        UserService,
        UserRoleService,
    ],
})
export default class CITCKeywords extends Vue {
    @Inject(CITCKeywordsService) public cITCKeywordsService!: CITCKeywordsService;
    @Inject(UserService) public userService!: UserService;
    @Inject(UserRoleService) public userRoleService!: UserRoleService;
    @Prop({ type: Boolean, default: false })
    public layoutSup: boolean | any;
    public deleteDialog: boolean = false;
    public cITCKeywordsId: string = '0';
    public name: string = '0';
    public User: any;
    public userRole: any;
    public headers: any = [
        { text: this.$t('shared.CITCKeywords'), value: 'name', align: 'center', sortable: false },
        { text: this.$t('shared.actions'), sortable: false, value: 'id', align: 'center', width: '100' },
    ];

    public cITCKeywordsModel: CITCKeywordsModel[] = [];
    public cITCKeywordsCount: number = 0;
    public filterCITCKeywords: CITCKeywordsModel[] = [];
    public filterModel: any = {
        id: '',
        name: '',
    };
    public async created() {
        this.User = await this.userService.getUser();
        this.userRole = this.GetUserRole();
        this.$emit('childinit', this.layoutSup);
    }
    public GetUserRole() {
        return this.userRoleService.GetUserRole(this.User);
    }
    public async mounted() {
        const response = await this.cITCKeywordsService.get(this.filterModel.name, '0', '10');
        if (!response.isSuccess) {
            Toaster.error(response.errorMessage);
        }
        this.cITCKeywordsModel = response.result;
        this.cITCKeywordsCount = response.totalCount;
    }
    @Watch('filterModel', { deep: true })
    public async search() {
        const response = await this.cITCKeywordsService.get(this.filterModel.name, '0', '10');
        if (!response.isSuccess) {
            Toaster.error(response.errorMessage);
        }
        this.cITCKeywordsModel = response.result;
        this.cITCKeywordsCount = response.totalCount;
    }

    public showDeleteDialog(id: string) {
        this.cITCKeywordsId = id;
        this.deleteDialog = true;
    }

    public hideDeleteDialog() {
        this.deleteDialog = false;
    }

    public async deleteCITCKeywords() {
        const response = await this.cITCKeywordsService.delete(this.cITCKeywordsId);
        if (response.isSuccess) {
            Toaster.success(this.$t('shared.deleteSuccessfully').toString());
            this.search();
        } else {
            Toaster.error(response.errorMessage);
        }
        this.deleteDialog = false;
    }
    public async reload() {
        const response = await this.cITCKeywordsService.get(this.filterModel.name, '0', '10');
        if (!response.isSuccess) {
            Toaster.error(response.errorMessage);
        }
        this.cITCKeywordsModel = response.result;
        this.cITCKeywordsCount = response.totalCount;
    }
    public async updatePaginate(val: any) {
        const response = await this.cITCKeywordsService.get(this.filterModel.name,
            (val.page - 1).toString(), val.rowsPerPage);
        this.cITCKeywordsModel = response.result;
        this.cITCKeywordsCount = response.totalCount;
    }

    public sleep(ms: number) {
        return new Promise((resolve) => {
            setTimeout(resolve, ms);
        });
    }
}
